import React, { useState } from 'react';
import SortButton from '../../UI/SortButton';
import classes from '../index.module.scss';

const PurchaseOpportunitiesTableHeader = () => {
  const [sortedBy, setSortedBy] = useState({
    posted_date: null,
    name: null,
    agency_name: null
  });

  return (
    <tr>
      <SortButton 
        name="Date Posted"
        sortBy="posted_date"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <SortButton 
        name="Opportunity/Contract"
        sortBy="name"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <th className={classes.Small_Width}>
        Type
      </th>
      <SortButton 
        name="Agency"
        sortBy="agency_name"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
    </tr>
  )  
}

export default PurchaseOpportunitiesTableHeader;